import {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import { useNavigate, useSearchParams } from "react-router-dom";
import {AddressAutoComplete} from '../../../components/AddressAutoComplete.jsx';
import './AddressUpdate.css';

export const AddressUpdate = ({token}) => {
  const navigate = useNavigate();
  const params = useParams();
  const [updating, setUpdating] = useState(false);
  const [addressText, setAddressText] = useState('');
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [updateCode, setUpdateCode] = useState('');
  const [autocompleteExpanded, setAutocompleteExpanded] = useState(false);
  const address1Ref = useRef();

  const handleChange = (event) => {
    setValues(inputs => ({...inputs, [event.target.name]: event.target.value}));
  };

  const address1KeyUp = (event) => {
    setAddressText(event.target.value);
  };

  const address1OnBlur = (event) => {
    setAddressText('');
  };

  const setAutocompleteVisible = (isVisible) => {
    console.log('autocomplete visible');
    console.log(isVisible);
    setAutocompleteExpanded(isVisible);
  };

  const setAddress = (address1, city, state, zipcode, address2) => {
    setValues(current => ({...current,
      address1: address1,
      city: city,
      state: state,
      zipcode: zipcode,
      address2: address2
    }));
  }

  useEffect(() => {
    if (params.code) {
      setUpdateCode(params.code);
      setValues(current => ({...current, 
        code: params.code
      }));
      fetch(`/customeraddress?code=${params.code}`, {
      }).then(response => {
        response.json().then(data => {
          if (data.ok) {
            setValues(current => ({...current, first_name: data.first_name, last_name: data.last_name, address1: data.address1, address2: data.address2, city: data.city, state: data.state, zipcode: data.zipcode}));
          } else {
            navigate('/');
          }
        });
      });
    } else {
        navigate('/');
    }

  }, []);

  const updateAddressClick = async () => {
    if (updating) {
        return;
    }
    setUpdating(true);
    const response = await fetch('/customeraddressupdate', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify(values)
    });
    const data = await response.json();
    setUpdating(false);
    if (data.ok) {
        navigate('/thankyouaddressupdate');
    }
    if (data.errors) {
        setErrors(data.errors);
    }
  };

  return (
  <div className="addressUpdateMain" >
    <div className="addressUpdateContent" >
        <div className="addressUpdateLogo" >
           <img alt="Drops" className="landingBarImg" src="/images/landing/Illustrations/Various_Illustrations/DROPS_LOGO_10_21.svg" />
        </div>
            <div className="addressUpdateForm">
                <form method="post" id="addressUpdateForm">
                        <div className="addressUpdateHeaderRow" >
                            <div className="addressUpdateHeader" >
                            <h3>Update address</h3>
                            </div>
                        </div>

                        <div className="addressUpdateNameRow" >
                            <div className={"addressUpdateFirstNameDiv " + (errors.first_name ? 'inputError' : '')} >
                                <div id="addressUpdateFirstNameLabel" className="addressUpdateFirstNameLabel" >
                                State
                                </div>
                                <input id="addressUpdateFirstNameEntry" className="addressUpdateFirstNameEntry" type="text" value={values.first_name} onChange={handleChange} name="first_name" placeholder="First Name" />
                            </div>
                            <div className={"addressUpdateLastNameDiv " + (errors.last_name ? 'inputError' : '')} >
                                <div id="addressUpdateLastNameLabel" className="addressUpdateLastNameLabel" >
                                Zipcode
                                </div>
                                <input id="addressUpdateLastNameEntry" className="addressUpdateLastNameEntry" type="text" value={values.last_name} onChange={handleChange} name="last_name" placeholder="Last Name" />
                            </div>

                        </div>

                        <div className="addressUpdateAddressRow" >
                            <div className={"addressUpdateAddressDiv " + (errors.address1 ? 'inputError' : '')} >
                                <div id="addressUpdateAddressLabel" className="addressUpdateAddressLabel" >
                                Address
                                </div>
                                <input id="address1" name="address1" className="addressUpdateAddressEntry" type="search" value={values.address1} onKeyUp={address1KeyUp} onChange={handleChange} onBlur={address1OnBlur} placeholder="Address" ref={address1Ref} autoComplete="none" aria-autocomplete="list" role="combobox" aria-multiline="false" aria-expanded={autocompleteExpanded} aria-controls="autocompleteList"/>
                                <AddressAutoComplete setAddress={setAddress} fieldRef={address1Ref} setAutocompleteVisible={setAutocompleteVisible}/>
                            </div>
                        </div>
                        <div className="addressUpdateAddress2Row" >
                            <div className="addressUpdateAddress2Div" >
                                <div id="addressUpdateAddress2Label" className="addressUpdateAddress2Label" >
                                Apartment, suite, etc (optional)
                                </div>
                                <input id="addressUpdateAddress2Entry" className="addressUpdateAddress2Entry" type="text" value={values.address2} onChange={handleChange} name="address2"  placeholder="Apartment, suite, etc (optional)"/>
                            </div>
                        </div>

                        <div className="addressUpdateCityRow" >
                            <div className={"addressUpdateCityDiv " + (errors.city ? 'inputError' : '')} >
                                <div id="addressUpdateCityLabel" className="addressUpdateCityLabel" >
                                City
                                </div>
                                <input id="addressUpdateCityEntry" className="addressUpdateCityEntry" type="text" value={values.city} onChange={handleChange} name="city" placeholder="City" />
                            </div>
                        </div>

                        <div className="addressUpdateCountryRow" >
                            <div className={"addressUpdateStateDiv " + (errors.state ? 'inputError' : '')} >
                                <div id="addressUpdateStateLabel" className="addressUpdateStateLabel" >
                                State
                                </div>
                                <input id="addressUpdateStateEntry" className="addressUpdateStateEntry" type="text" value={values.state} onChange={handleChange} name="state" placeholder="State" />
                            </div>
                            <div className={"addressUpdateZipcodeDiv " + (errors.zipcode ? 'inputError' : '')} >
                                <div id="addressUpdateZipcodeLabel" className="addressUpdateZipcodeLabel" >
                                Zipcode
                                </div>
                                <input id="addressUpdateZipcodeEntry" className="addressUpdateZipcodeEntry" type="text" value={values.zipcode} onChange={handleChange} name="zipcode" placeholder="Zipcode" />
                            </div>

                        </div>

                        <div className="addressSubtextRow">
                        *Please change your address to one in the U.S. that can receive USPS, UPS, and FedEx packages.
                        </div>

                        <div className="addressUpdateSubmit" disabled={updating} id="addressUpdateSubmit" onClick={updateAddressClick}>
                            <div className="addressUpdateSubmitText">
                            Update
                            </div>
                        </div>
                </form>
            </div>
        
    </div>
  </div>
  );
}

